import React from 'react';
import propTypes from 'prop-types';
import { workDriveEmbedSrc } from 'helpers/tableSpecialCells/embedding';

// middle card of the oep updates grid: embeds the carrier's oep workdrive
// folder. only shows when the oep-specific url is set on the carrier record.
// workdrive scrolls its own file list, so scrolling='no' drops the iframe's
// outer scrollbar that otherwise stacks next to it
function CarrierResourcesPanel({ carrier }) {
  const url = carrier?.oepResourcesWorkDriveURL;

  return (
    <div
      data-tour='oep-resources-panel'
      className='flex min-h-[420px] flex-col overflow-hidden rounded-xl border border-grey-lightest bg-white p-4'
    >
      <h3 className='m-0 mb-3 text-xl font-semibold text-black'>
        Carrier Resources
      </h3>
      {url ? (
        <iframe
          title='OEP Carrier Resources'
          allowFullScreen
          scrolling='no'
          className='min-h-0 w-full flex-1 rounded-md border-none'
          src={workDriveEmbedSrc(url)}
        />
      ) : (
        <div className='flex flex-1 items-center justify-center text-sm text-gray-400'>
          No OEP resources published for this carrier yet.
        </div>
      )}
    </div>
  );
}

CarrierResourcesPanel.propTypes = {
  carrier: propTypes.object.isRequired
};

export default CarrierResourcesPanel;
